module.exports = __webpack_public_path__ + "media/images/waves-a6cab9f8109d667ca0a14f618854cb5d.png";